import * as React from "react";
import {useTranslation} from "react-i18next";
import styles from "./PaymentMethodsBanner.module.scss";

/**
 * @component
 */
export function PaymentMethodsBanner(): React.ReactElement {
  const {t} = useTranslation();
  const lang = `paymentcard-${document.body.dataset.lang || "en"}`;

  return (
    <div className={styles.wrapper}>
      <span className="icon icon-paymentcard-paypal">&#160;</span>
      <span className={`icon icon-paymentcard-creditcard ${lang}`}>
        <span className="icon__content">{t("general.creditCard")}</span>
      </span>
      <span className={`icon icon-paymentcard-prepayment ${lang}`}>
        <span className="icon__content">
          {t("general.prepayment")}
          <span className="icon__content__value">3%</span>
        </span>
      </span>
      <span className={`icon icon-paymentcard-invoice ${lang}`}>
        <span className="icon__content">{t("general.invoice")}</span>
      </span>
    </div>
  );
}
